import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TagsDataAccessModule } from "@vp/data-access/tags";
import { AgePipe } from "./age.pipe";
import { CaseRecordDataPipe } from "./case-record-data.pipe";
import { CaseStatusPipe } from "./case-status.pipe";
import { CaseTypeDisplayPipe } from "./case-type-display.pipe";
import { DaysBetweenTwoDatesPipe } from "./days-between-two-dates.pipe";
import { DepartmentPipe } from "./department.pipe";
import { FileSizePipe } from "./file-size.pipe";
import { LinkifyPipe } from "./linkify.pipe";
import { RolePipe } from "./role.pipe";
import { TagDisplayPipe } from "./tag-display.pipe";
import { TagSortPipe } from "./tag-sort.pipe";
import { TagTypeDisplayNamePipe, TagTypePipe } from "./tag-type.pipe";
import { TagsArrayPipe } from "./tags-array.pipe";
import { UiDisplayTagsPipe } from "./ui-display-tags.pipe";
import { UserNamePipe } from "./user-name.pipe";
import { FileTypesPipe } from "./file-types.pipe";

@NgModule({
  imports: [CommonModule, TagsDataAccessModule],
  exports: [
    CaseStatusPipe,
    DaysBetweenTwoDatesPipe,
    DepartmentPipe,
    FileSizePipe,
    LinkifyPipe,
    RolePipe,
    TagDisplayPipe,
    TagSortPipe,
    TagTypePipe,
    TagTypeDisplayNamePipe,
    UserNamePipe,
    CaseRecordDataPipe,
    TagsArrayPipe,
    UiDisplayTagsPipe,
    CaseTypeDisplayPipe,
    AgePipe,
    FileTypesPipe
  ],
  declarations: [
    CaseStatusPipe,
    DaysBetweenTwoDatesPipe,
    DepartmentPipe,
    FileSizePipe,
    LinkifyPipe,
    RolePipe,
    TagDisplayPipe,
    TagSortPipe,
    TagTypePipe,
    TagTypeDisplayNamePipe,
    UserNamePipe,
    CaseRecordDataPipe,
    TagsArrayPipe,
    UiDisplayTagsPipe,
    CaseTypeDisplayPipe,
    FileSizePipe,
    LinkifyPipe,
    AgePipe,
    FileTypesPipe
  ]
})
export class ContextDisplayModule {}
